import * as React from 'react';
import {Box} from '@mui/material';
import {useRecordContext} from 'react-admin';

const toSvgDataUrl = (iconSvg: string) => `data:image/svg+xml;charset=utf-8,${encodeURIComponent(iconSvg)}`;

interface RiskCategoryIconPreviewProps {
  compact?: boolean;
  record?: any;
}

export const RiskCategoryIconPreview = ({compact = false, record: suppliedRecord}: RiskCategoryIconPreviewProps) => {
  const contextRecord = useRecordContext<any>();
  const record = suppliedRecord ?? contextRecord;
  if (!record?.iconSvg) {
    return null;
  }

  const size = compact ? 28 : 72;
  return (
    <Box
      component="img"
      alt="Kategoriikon"
      src={toSvgDataUrl(record.iconSvg)}
      sx={{
        width: size,
        height: size,
        backgroundColor: 'action.hover',
        border: '1px solid',
        borderColor: 'divider',
        borderRadius: 1,
        padding: compact ? 0.25 : 1,
      }}
    />
  );
};
